// extracted by mini-css-extract-plugin
export default {"container":"UWHyIY5MhnZodOepf07L","header":"gOTyiP_xsr_sruTWYaUn","badge":"k5INtxhBkvpyBcCQSyeg","collapseTrigger":"xHJ4Ags2cW_d1XGzIsNX","description":"mMD84lqbEAZ8j9Y76BmI"};